$(document).ready(function(){
  
  if($(window).width() > 800){
    $('.slider-image-block').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '20%',
  });
  }else{
    $('.slider-image-block').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '20%',
      arrows : false
  });
  }
});	
$( window ).on( "resize", function() {
  
  if($(window).width() > 800){
    $('.slider-image-block').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '20%',
  });
  }else{
    $('.slider-image-block').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '20%',
      arrows : false
  });
  }
});	